import { render, staticRenderFns } from "./ProveedorEdit.vue?vue&type=template&id=f126cf44&"
import script from "./ProveedorEdit.vue?vue&type=script&lang=js&"
export * from "./ProveedorEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports